import { IHttpInterceptor, ILogService, IHttpResponse, IRequestConfig } from "angular";
import { $InjectorLike } from "angular-ui-router";
import { HttpInterceptorFactory } from "./http-interceptor.factory";

export class AbortedXhrError extends Error implements IHttpResponse<any> {
    name = "AbortedXhrError";
    status = -1;
    statusText = "";
    xhrStatus: "abort" = "abort";
    config: IRequestConfig;
    data: any;
    headers: any;
    constructor(message: string, detail: IHttpResponse<any>) {
        super(message);
        this.status = detail.status;
        this.config = detail.config;
        this.data = detail.data;
        this.headers = detail.headers;
        this.statusText = detail.statusText;
    }
}

export class HttpResponseError extends Error implements IHttpResponse<any> {
    name = "HttpResponseError";
    status: number;
    config: IRequestConfig;
    data: any;
    headers: () => any;
    statusText: string;
    xhrStatus: "error" = "error";
    constructor(detail: IHttpResponse<any>) {
        super(detail.statusText || detail.status?.toString());
        this.status = detail.status;
        this.config = detail.config;
        this.data = detail.data;
        this.headers = detail.headers;
        this.statusText = detail.statusText;
    }
}

/**
 * An interceptor that wrap failed requests in an error for improved
 *
 */
export class ApexApiResponseInterceptor implements IHttpInterceptor {
    constructor(private $injector: $InjectorLike, private $log: ILogService) {
        'ngInject';
    }

    responseError(rejection: IHttpResponse<any>): IHttpResponse<any> {
        const apexApiUrl = this.$injector.get("apexApiUrl");
        if (!rejection.config || !rejection.config.url.includes(apexApiUrl) || rejection instanceof Error) {
            // This interceptor only processes rejections in the form of an unsuccessful XHR response.
            throw rejection;
        }
        const response = rejection as IHttpResponse<any>;
        if (response.xhrStatus === "abort") {
            // Wrap aborted XHR requests in a special error, for improved tracing.
            throw new AbortedXhrError("The connection was aborted", response);
        }
        if (response.status <= 0) {
            // If the XHR wasn't aborted, but status code is still -1, this indicates
            // a network issue (eg, server request was blocked, server shut down halfway through the request,
            // or user lost internet connection)
            throw new AbortedXhrError("The connection was reset or blocked", response);
        }
        // For all other HTTP request errors, wrap them in an error instead of throwing the response
        // directly so that a stack trace is produced and the error is meaningful.
        throw new HttpResponseError(response);
    }
}

export const apexApiResponseInterceptorFactory = HttpInterceptorFactory(ApexApiResponseInterceptor);
